<template>
  <modal
    class="addDriver"
    name="makeSettlementRequest"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.bSettlement.makeSetRequest") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="">
              <div style="display: flex; justify-content: center">
                <h5
                  class="text-muted border border-warning border-3 rounded-pill p-2 ml-5"
                >
                  {{ $t("text.bWallet.walletBalance") }}:
                  <span v-if="!gettingBal">{{ walletBal }}</span>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader1"
                  />
                </h5>
              </div>
            </div>

            <div v-show="wallBal">
              <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-2"
                  v-model="toggleCustom"
                  :aria-describedby="ariaDescribedby"
                  name="radio-sub-component"
                >
                  <b-form-radio :value="false">{{
                    $t("text.bSettlement.settleWalletAmt")
                  }}</b-form-radio>
                  <b-form-radio :value="true">{{
                    $t("text.bSettlement.settleCustomAmt")
                  }}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div
              v-if="toggleCustom"
              class="mt-4"
              style="width: 70%; margin: auto"
            >
              <div style="display: flex; justify-content: flex-start">
                <label class="required">
                  {{ $t("text.cBank.amount") }}
                </label>
              </div>
              <div class="input__block" ref="target_input_div">
                <input
                  style="padding: 20px; width: 100%"
                  type="number"
                  min="0"
                  :placeholder="$t('text.cBank.amount')"
                  v-model="amount"
                />
              </div>
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="makeSettlementRequest($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.categories.create") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";

import Multiselect from "vue-multiselect";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "makeSettlementRequest",
  props: ["branchId"],
  components: {
    Multiselect,
  },
  data() {
    return {
      walletBal: 0,
      amount: 0,
      toggleCustom: false,
      gettingBal: true,
      wallBal: false,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
    };
  },

  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    opened() {
      this.getWalletBal();
    },
    // checkAmtRange() {
    //   if (this.amount > this.walletBal) {
    //     this.$toast.open({
    //       message: this.$t("text.bSettlement.inputGreater"),
    //       type: "error",
    //       duration: 3000,
    //     });
    //     this.amount = this.amount.replace(/.$/, "");
    //   }
    // },

    getWalletBal() {
      this.gettingBal = true;
      $(".loader1").show();
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BranchWalletBalance/${this.branchId.id}`,

          configObject.authConfig()
        )
        .then((response) => {
          this.walletBal = response.data.balance;
          this.gettingBal = false;
          this.wallBal = true;
          $(".loader1").hide();
        })
        .catch((err) => {});
    },

    makeSettlementRequest($event) {
      $event.preventDefault();

      if (this.amount > this.walletBal) {
        this.$toast.open({
          message: this.$t("text.bSettlement.inputGreater"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.toggleCustom && this.amount == 0) {
        this.$toast.open({
          message: this.$t("text.errors.accountNameMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      $(".loader").show();
      this.isButtonDisabled = true;
      let data = {
        branchId: this.branchId.id,
        amount: this.toggleCustom
          ? parseFloat(this.amount)
          : parseFloat(this.walletBal),
        isToBePaidToBranchAccount: true,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/SettlementRequest/Branch/Create`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.$toast.open({
            message: this.$t("text.products.requestSent"),
            type: "success",
            duration: 5000,
          });

          this.closeModal();
          this.$eventHub.$emit("getSettlementRequest");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },

    // validEmail(email) {
    //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    //     return true;
    //   }
    //   return false;
    // },
    closed() {
      this.amount = 0;
      this.toggleCustom = false;
    },
    closeModal() {
      this.$modal.hide("makeSettlementRequest");
      this.amount = 0;
      this.toggleCustom = false;
    },
  },
};
</script>
